export default Object.freeze({
  SPECTATORS: 'spectators',
})
